import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  CreateProviderWarehouseDto,
  ProviderWarehouse,
  ProviderWarehouseDelivery,
  ProviderWarehouseDeliveryResponse,
  SearchProviderWarehouseDto,
  UpdateProviderWarehouseDto
} from 'src/typings';
import { AuthService } from '../login/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProviderWarehouseService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  create(payload: CreateProviderWarehouseDto) {
    return this.http.post<ProviderWarehouse>(
      `${environment.BACKEND}/provider-warehouse/create`,
      payload
    );
  }

  update(payload: UpdateProviderWarehouseDto) {
    return this.http.put<ProviderWarehouse>(
      `${environment.BACKEND}/provider-warehouse/update`,
      payload
    );
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/provider-warehouse/${id}`);
  }

  getOne(id: number) {
    return this.http.get<ProviderWarehouse>(`${environment.BACKEND}/provider-warehouse/${id}`);
  }

  getDelivery(providerWarehouseId: number, receiverWarehouseId: number) {
    return this.http.get<ProviderWarehouseDeliveryResponse>(
      `${environment.BACKEND}/provider-warehouse/${providerWarehouseId}/delivery/${receiverWarehouseId}`
    );
  }

  updateDelivery(
    providerWarehouseId: number,
    receiverWarehouseId: number,
    delivery: ProviderWarehouseDelivery | null
  ) {
    return this.http.put<ProviderWarehouseDeliveryResponse>(
      `${environment.BACKEND}/provider-warehouse/${providerWarehouseId}/delivery/${receiverWarehouseId}`,
      { delivery }
    );
  }

  search(payload: SearchProviderWarehouseDto) {
    return this.http.post<{ data: ProviderWarehouse[]; length: number }>(
      `${environment.BACKEND}/provider-warehouse/search`,
      payload
    );
  }
}
